export default "__VITE_ASSET__DqxyWNfc__"